import scssData from 'util/dom/scss-data';
import $ from 'bianco.query';

// Get data from the dom
const { breakpoints, 'product-tile-amounts': productTileAmounts } = scssData($('.scss-data-bridge')[0]);

/**
 * Get the width of a breakpoint by name
 * @param name
 * @returns {Number}
 */
function bp(name) {
    return parseInt(breakpoints[name]);
}

export default {
    speed: 450,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    slidesPerView: 'auto',
    spaceBetween: 0,
    allowTouchMove: false,
    breakpoints: {
        [bp('xs')]: {
            slidesPerGroup: productTileAmounts['xs'],
            freeMode: true,
        },
        [bp('sm')]: {
            slidesPerGroup: productTileAmounts['sm'],
        },
        [bp('md')]: {
            slidesPerGroup: productTileAmounts['md'],
        },
        [bp('lg')]: {
            slidesPerGroup: productTileAmounts['lg'],
        },
        [bp('xl')]: {
            slidesPerGroup: productTileAmounts['xl'],
        },
        max: { // anything else
            slidesPerGroup: productTileAmounts['xxl'],
        },
    },
};

export { productTileAmounts };



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/products-slider/slider-config.js